<template>
  <div v-if="showModal" class="modal false z-50 fixed w-full h-full top-0 left-0 flex items-center justify-center">
    <div class="absolute w-full h-full bg-gray-900 opacity-50 modal-overlay" @click="showModal = false"></div>
    <div class="z-50 w-11/12 mx-auto overflow-y-auto bg-white rounded shadow-lg modal-container md:max-w-5xl">
      <div class="flex-auto">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div v-if="resource" class="text-base leading-relaxed text-gray-500">
            <!-- header -->
            <div class="flex justify-between items-start p-5 rounded-t border-b">
              <h3 class="text-xl font-semibold text-gray-900 lg:text-xl dark:text-white">
                {{ $lang.app.DETAIL }}
              </h3>
              <button
                  @click="showModal = false"
                  type="button"
                  class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5
                ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white">
                <XIcon class="w-5 h-5"/>
              </button>
            </div>
            <!-- body -->
            <div class="p-6">
              <div class="mb-5 flex justify-start text-black">
                <label class="w-1/4">{{ $lang.app.TYPE }}</label>
                <div class="w-3/4 font-medium">
                  {{ resource.type.name }}
                </div>
              </div>
              <div class="mb-5 flex justify-start text-black">
                <label class="w-1/4">{{ $lang.app.DENOMINATION }}</label>
                <div class="w-3/4 font-medium">
                  {{ resource.name }}
                </div>
              </div>
              <div class="mb-5 flex justify-start text-black">
                <label class="w-1/4">{{ $lang.app.SHORT_DENOMINATION }}</label>
                <div class="w-3/4 font-medium">
                  {{ resource.shortName }}
                </div>
              </div>
              <div class="mb-5 flex justify-start text-black">
                <label class="w-1/4">{{ $lang.app.NUMBER }}</label>
                <div class="w-3/4 font-medium">
                  {{ resource.number }}
                </div>
              </div>
              <div class="mb-5 flex justify-start items-baseline text-black">
                <label class="w-1/4">{{ $lang.app.CREATION_DATE }}</label>
                <div class="w-3/4 font-medium">
                  {{ $moment(resource.createdAt).format('DD.MM.YYYY HH:mm') }}
                </div>
              </div>
            </div>

            <!-- footer -->
            <div class="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
              <button
                  @click="showModal = false"
                  type="button"
                  class="text-gray-500 bg-white hover:bg-gray-100 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900"
              >
                {{ $lang.app.CLOSE }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sectionDocumentApi from "../../../../api/admin/sectionDocument";

export default {
  data() {
    return {
      showModal: false,
      resource: null,
    }
  },
  beforeMount() {
    this.$emitter.on('open-admin-detail-section-document-modal', item => {
      sectionDocumentApi.detail(item.id).then(res => {
        this.resource = res
        this.showModal = true
      })
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-admin-detail-section-document-modal')
  }
};
</script>
